// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1udqP","title":"Info_title__2BiDa","selects":"Info_selects__3A-9I","requiredAsterisk":"Info_requiredAsterisk__CCCvv"};